module.exports = __webpack_public_path__ + "img/paid.c9bd4921.png";